import { post, postJson, deleteApi, put, get, imagePost, putJson,postBlob } from './axios3'

// 创建问卷调查
export const questionnaireSave = p => postJson(`/questionnaire/save`, p)

// 查询问卷调查详情
export const questionnaireDetail = id => get(`/questionnaire/${id}`)

// 查询问卷调查记录
export const getQuestionnaireRecord = p => postJson(`/questionnaire/getRecordPage`, p)

// 导出问卷调查记录
export const exportQuestionnaireRecord = p => postJson(`/questionnaire/exportRecord`, p)

//问卷统计
export const getQuestionSummary = p => get('/questionnaire/getQuestionSummary', p)

//参与记录导出
export const trialRebuyExport = p => postJson(`/trialRebuy/export`, p)

//领奖记录导出
export const winRecordExports = p => postJson(`/trialRebuy/winRecordExport`, p)

// 单个/批量审核问卷记录
export const processQuestionnaireRecord = p => postJson("/questionnaire/process", p)

// 剩余可通过审批人数接口
export const getQtCanProcessNum = p => get('/questionnaire/canProcessNum', p)